import { render } from "./CleaningComponent.vue?vue&type=template&id=243f80eb"
import script from "./CleaningComponent.vue?vue&type=script&lang=js"
export * from "./CleaningComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__